<template>
  <div>
    <!-- 🎯 전체 툴바 구성 -->
    <div id="custom-toolbar">
      <!-- 폰트 사이즈 -->
      <select class="ql-size">
        <option value="12px">12px</option>
        <option value="14px">14px</option>
        <option value="16px" selected>16px</option>
        <option value="20px">20px</option>
        <option value="24px">24px</option>
        <option value="32px">32px</option>
      </select>

      <!-- 헤딩 -->
      <select class="ql-header">
        <option selected></option>
        <option value="1">제목 1</option>
        <option value="2">제목 2</option>
        <option value="3">제목 3</option>
      </select>

      <!-- 정렬 -->
      <select class="ql-align">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>

      <!-- 텍스트 스타일 -->
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>

      <!-- 색상 -->
      <select class="ql-color"></select>
      <select class="ql-background"></select>

      <!-- 리스트 및 들여쓰기 -->
      <button class="ql-list" value="ordered"></button>
      <button class="ql-list" value="bullet"></button>
      <button class="ql-indent" value="-1"></button>
      <button class="ql-indent" value="+1"></button>

      <!-- 인용구, 코드블럭 -->
      <button class="ql-blockquote"></button>
      <button class="ql-code-block"></button>

      <!-- 링크, 이미지 -->
      <button class="ql-link"></button>
      <button class="ql-image"></button>

      <!-- 초기화 -->
      <button class="ql-clean"></button>
    </div>

    <div ref="editorRoot" class="quill-editor"></div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, watch } from 'vue';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// ✅ px 단위 font-size 등록
const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '32px'];
Quill.register(SizeStyle, true);

const props = defineProps({ modelValue: String });
const emit = defineEmits(['update:modelValue']);

const editorRoot = ref(null);
let quill;

// 이미지 핸들러 (base64 삽입)
function imageHandler() {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();
  input.onchange = () => {
    const file = input.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const range = quill.getSelection();
      quill.insertEmbed(range.index, 'image', reader.result);
    };
    reader.readAsDataURL(file);
  };
}

onMounted(() => {
  quill = new Quill(editorRoot.value, {
    theme: 'snow',
    modules: {
      toolbar: {
        container: '#custom-toolbar',
        handlers: { image: imageHandler }
      }
    },
    placeholder: '내용을 입력하세요...'
  });

  // 최초 값 설정 및 자동 복구
  const saved = localStorage.getItem('draftNotice');
  const initialValue = props.modelValue || saved || '';
  quill.clipboard.dangerouslyPasteHTML(initialValue);
  emit('update:modelValue', quill.root.innerHTML);

  // 텍스트 변경 시 모델 반영
  quill.on('text-change', () => {
    const html = quill.root.innerHTML;
    emit('update:modelValue', html);
    localStorage.setItem('draftNotice', html);
  });
});

// 외부 변경 감지
watch(() => props.modelValue, (val) => {
  if (quill && quill.root.innerHTML !== val) {
    quill.root.innerHTML = val || '';
  }
});

onBeforeUnmount(() => {
  quill = null;
});
</script>

<style scoped>
.quill-editor {
  height: 500px;
  border: 1px solid #ccc;
  font-family: "Noto Sans KR", sans-serif;
}
.ql-toolbar {
  background-color: #f5f5f5;
  border-radius: 4px 4px 0 0;
}
.ql-editor {
  font-size: 16px;
  line-height: 1.7;
  padding: 20px;
}

/* ✅ px 단위 size 클래스 등록 */
.ql-size-12px { font-size: 12px; }
.ql-size-14px { font-size: 14px; }
.ql-size-16px { font-size: 16px; }
.ql-size-20px { font-size: 20px; }
.ql-size-24px { font-size: 24px; }
.ql-size-32px { font-size: 32px; }
</style>
